import { render, staticRenderFns } from "./RunData.vue?vue&type=template&id=5cb1c853&"
import script from "./RunData.vue?vue&type=script&lang=ts&"
export * from "./RunData.vue?vue&type=script&lang=ts&"
import style0 from "./RunData.vue?vue&type=style&index=0&id=5cb1c853&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports